import { media } from '../../styles';
import styled from 'styled-components';

type FooterProps = {
  showBorder: boolean;
};

export const FooterWrapper = styled.div<FooterProps>`
  border-top: ${({ theme, showBorder }) => (showBorder ? `1px solid ${theme.typography.color.tertiary}` : 'none')};
  background-color: ${({ theme }) => theme.ui.layer.backgroundColor};
  display: block;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  padding: ${({ theme }) => `0 ${theme.spacing.base.xl} ${theme.spacing.base.sm}`};

  ${media.mobilePortrait} {
    padding: ${({ theme }) => `0 ${theme.spacing.mobile.xxxl} ${theme.spacing.mobile.xxxl}`};
    flex: 0 0 auto;
  }
`;

export const FooterContainer = styled.div`
  display: block;
  font-size: ${({ theme }) => theme.typography.size.xsmall};
  font-weight: ${({ theme }) => theme.typography.weight.regular};
  justify-content: center;
  min-height: 0px;
  text-align: center;
  width: 100%;
`;
